export default __webpack_public_path__ + "2026a76aae366cdc6074e6314e1d530b.png";